import { render } from "./IconEmptyVodFiles.vue?vue&type=template&id=8685048c"
const script = {}

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/icon/IconEmptyVodFiles.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "8685048c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('8685048c', __exports__)) {
    api.reload('8685048c', __exports__)
  }
  
  module.hot.accept("./IconEmptyVodFiles.vue?vue&type=template&id=8685048c", () => {
    api.rerender('8685048c', render)
  })

}


export default __exports__